import { GetServerSidePropsContext } from 'next';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import BookingSteps, { STEPS_TYPE } from '@/organisms/booking-steps';
import RedirectToHome from '@/organisms/redirect-to-home';
import getDayPassProps from '@core/booking/actions/getDayPassProps';
import { useSettingsStore } from '@core/settings/store/settings';

const BookingDayPassPage = ({ locations }) => {
  const { t } = useTranslation();
  const { isDayPassEnabled } = useSettingsStore();
  const router = useRouter();

  useEffect(() => {
    if (!isDayPassEnabled) {
      router.push(`/home?clientName=${router.query.clientName}`);
    }
  }, []);

  if (!isDayPassEnabled) return <RedirectToHome message={t('booking.notAllowedDayPass')} />;

  return <BookingSteps stepsType={STEPS_TYPE.DAY_PASS} locations={locations} />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  return getDayPassProps(context.query);
}

export default BookingDayPassPage;
